import { Expose, Type } from 'class-transformer'

import { Facility } from './Facility'
import { Sku } from './Sku'

export enum SkuThresholdTarget { 
  tot = 'Global Total',
  fac = 'Per Facility',
}

export class SkuThreshold {
  static Target = SkuThresholdTarget

  guid: string = ''

  @Type(() => Sku)
  sku?: Sku

  target: SkuThresholdTarget = SkuThresholdTarget.tot

  @Type(() => Facility)
  facility?: Facility

  @Expose({ name: 'min_count' })
  minCount: number = 0

  @Expose({ name: 'refill_count' })
  refillCount?: number

  triggered: boolean = false

  get name() {
    const facilityStr = this.facility ? `${this.facility.name} ` : ''
    return `${this.target} ${facilityStr}< ${this.minCount}`
  }

  get status() {
    return !this.triggered
  }
}
